import { PropertyPanel } from "@serenity-is/corelib";
import { ErrorHandling, isEmptyOrNull, localText, notifyError, parseQueryString, resolveUrl, serviceCall, ServiceResponse } from "@serenity-is/corelib/q";
import { LoginForm, LoginRequest } from "@/ServerTypes/MasterAdmin";



$( () => {

  const loginPanel = new LoginPanel( $( "#LoginPanel" ) ).init();
  loginPanel.element.find( ".forgot-password" ).append( ".field.Password" );

  if ( (document.getElementById( "IsDevelopment" ) as HTMLInputElement )?.value ) { // it exists, and is 'truthy'
    loginPanel["byId"]( "Username" ).attr( "placeholder", "username" ).val( "root@recon.com" );
    loginPanel["byId"]( "Password" ).attr( "placeholder", "password" ).val( "R3dC1rcle!" );
  }
  else {
    loginPanel["byId"]( "Username" ).attr( "placeholder", "username" );
    loginPanel["byId"]( "Password" ).attr( "placeholder", "password" );
  }

} );

let _versionString: string;

class LoginPanel extends PropertyPanel<LoginRequest, any> {

  protected getFormKey(): string {
    return LoginForm.formKey;
  }

  constructor( container: JQuery ) {
    _versionString = $( "#versionString" ).val();
    super( container );

    this.byId( "LoginButton" ).click( e => {
      e.preventDefault();

      if ( !this.validateForm() )
        return;

      const request = this.getSaveEntity();

      serviceCall( {
        url: resolveUrl( "~/auth/login" ),
        request: request,
        onSuccess: _ => {
          this.redirectToReturnUrl();
        },
        onError: ( response: ServiceResponse ) => {
          if ( response?.Error?.Code === "RedirectUserTo" ) {
            window.location.href = response.Error.Arguments;
            return;
          }

          if ( response?.Error != null && !isEmptyOrNull( response.Error.Message ) ) {
            notifyError( response.Error.Message );
            $( "#Password" ).focus();
            return;
          }

          ErrorHandling.showServiceError( response?.Error );
        }
      });
    });
  }

  protected redirectToReturnUrl() : void {
    const q = parseQueryString();
    let returnUrl = q[ "returnUrl" ] || q[ "ReturnUrl" ];
    if ( returnUrl ) {
      const hash: string = window.location.hash;
      if (hash != null && hash != "#")
        returnUrl += hash;
      window.location.href = returnUrl;
    }
    else {
      window.location.href = resolveUrl( "~/" );
    }
  }

  protected getTemplate(): string {
    return `
    <h2 class="text-center p-4">
        <img src="${resolveUrl("~/Content/site/images/logo-spotlight.png")}"
            class="p-1" alt="image-serenity" />
    </h2>
    <p class="text-center">Powered by RECON</p>

    <div class="s-Panel p-4">
        <h5 class="text-center my-4">${localText("Forms.Membership.Login.LoginToYourAccount")}</h5>
        <form id="~_Form" action="">
            <div id="~_PropertyGrid"></div>
            <div class="px-field">
                <button id="~_LoginButton" type="submit" class="btn btn-primary my-3 w-100">
                    ${localText("Forms.Membership.Login.SignInButton")}
                </button>
            </div>
        </form>
    </div>
    <div>
      <p id="txtVersionString" class="text-center" style="margin-top: 5px;">v${_versionString}</p>
    </div>
    `;

  }
}